//记得在 src\components\lang\zhLoad.js 里面添加对象
const role= {
    roleCode: 'RoleCode',
    roleName: 'RoleName',
    remark:'Remark',
    menuList:"MenuList",
    permission:"Permission",
    addRole:'AddRole',
    editRole:'RoleEdit',
    activeOff:'ActiveOff',
    exportData:'ExportPermission',
    assignPermission:'AssignPermissions',
    roleType:"角色类型",
    msg:{
        roleName:'Please input the RoleName',
        roleCode:'Please input the RoleCode',
        clientId:"Please select the clientId"
    }
};
export default role



// WEBPACK FOOTER //
// ./src/page/auth/role/lang/role.en.js